import React, { useEffect, useState } from 'react'
import { Form, Input, Button, Col, Row, Select } from 'antd'
import apiRequest from '../../hooks/ApiRequest'
import { toast } from 'react-toastify'

const { Option } = Select

const MasterBrokerForm = props => {
  const { form, UnderWriterID, MasterBrokerID, recordID, onSuccess, modalVisible } = props
  console.log('UnderWriterID:', UnderWriterID, MasterBrokerID);

  const { getFieldDecorator } = form
  const [loading, setLoading] = useState(false)
  const [underwriterList, setUnderwriterList] = useState([]);
  const [recordId, setRecordId] = useState(0);
  const [masterBrokerList, setMasterBrokerList] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);

  useEffect(() => {
    fetchUnderwriters();
    fetchMasterBrokers();
    if (UnderWriterID && MasterBrokerID) {
      form.setFieldsValue({ masterBrokerId: MasterBrokerID })
      form.setFieldsValue({ underWriterId: UnderWriterID })
      setRecordId(recordID);
    } else if (UnderWriterID) {
      form.setFieldsValue({ underWriterId: UnderWriterID })
    } else {
      form.resetFields()
    }
  }, [UnderWriterID, modalVisible, MasterBrokerID])

  const fetchUnderwriters = async () => {
    try {
      const loggedInUserId = localStorage.getItem('loggedInUserID');
      const loggedInUserRole = JSON.parse(localStorage.getItem('roles'));
      let response = [];
      const underwritersList = [];
      if (loggedInUserRole === 'SuperAdmin') {
        // SuperAdmin gets ALL underwriters
        const underwriters = await apiRequest(
          `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/UsersForDropdown/underwriter`,
          'GET'
        );

        response = underwriters.data || [];
      } else {
        // For other roles (e.g. MasterBroker), get relationship-based underwriters
        const res = await fetchRelations([loggedInUserId]);

        for (let i = 0; i < res.length; i++) {
          const rel = res[i];
          if (rel.assignorId === parseInt(loggedInUserId)) {
            underwritersList.push({
              id: rel.assigneeId,
              name: rel.assigneeName,
            });
          }
        }

        response = underwritersList;
      }

      setUnderwriterList(response);
    } catch (err) {
      console.error('Error fetching underwriters:', err);
    }
  };


  const fetchMasterBrokers = async () => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/UsersForDropdown/masterbroker`,
        'GET'
      );
      setMasterBrokerList(response?.data || []);
    } catch (err) {
      console.error('Error fetching master brokers:', err);
    }
  };

  const fetchRelations = async (payload) => {
    const url = `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/GetUserRelationship`;
    const res = await apiRequest(url, 'POST', payload);

    if (res?.success) {
      return res.data;
    } else {
      return [];
    }
  };

  const handleSubmit = e => {
    e.preventDefault()
    form.validateFields(async (err, values) => {
      if (err) return
      setLoading(true)
      try {
        const selectedMasterbroker = masterBrokerList.find(ins => ins.id === values.masterBrokerId)
        const selectedUnderwriter = underwriterList.find(u => u.id === values.underWriterId)

        if (!selectedMasterbroker || !selectedUnderwriter) {
          toast.error('Invalid Insurer or UnderWriter selected')
          setLoading(false)
          return
        }

        const payload = {
          AssignorId: selectedUnderwriter?.id,
          AssignorName: selectedUnderwriter?.name,
          childDto: [
            {
              AssigneeId: selectedMasterbroker?.id,
              AssigneeName: selectedMasterbroker?.name
            }
          ],
          id: recordId
        }

        const url = `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/AssignedSubordinates`

        const res = await apiRequest(url, 'POST', payload)
        if (res.success) {
          if (res.data?.success) {
            toast.success(UnderWriterID ? 'Master Broker Updated!' : 'Master Broker Assigned!')
            onSuccess()
          }
          else {
            toast.error(res.data.message || 'Something went wrong')
          }
        } else {
          const msg = res.error?.toLowerCase?.() || ''
          toast.error(res.error || 'Something went wrong')
        }
      }
      catch (err) {
        console.error('Submit error:', err)
        toast.error('Request failed, try again.')
      } finally {
        setLoading(false)
      }
    })
  }

  return (
    <div className="container mt-3">
      <div className="card p-4">
        <Form layout="vertical" onSubmit={handleSubmit}>
          <Row gutter={16}>
            <Col md={12}>
              <Form.Item label="Select UnderWriter">
                {getFieldDecorator('underWriterId', {
                  rules: [{ required: true, message: 'Please select an underwriter' }],
                })(
                  <Select placeholder="Select UnderWriter">
                    {underwriterList?.map(u => (
                      <Option key={u.id} value={u.id}>
                        {u.name}
                      </Option>
                    ))}
                  </Select>,
                )}
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item label="Select Master Broker">
                {getFieldDecorator('masterBrokerId', {
                  rules: [{ required: true, message: 'Please select an Master Broker' }],
                })(
                  <Select placeholder="Select Master Broker">
                    {masterBrokerList?.map(u => (
                      <Option key={u.id} value={u.id}>
                        {u.name}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              className="btn-success">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  )
}

export default Form.create()(MasterBrokerForm)
